<template>
    <div>
        <!-- 单个导航项 -->
        <div class="nav-item" :class="{ active: activeSection == item.id }" :style="{ paddingLeft: `${level * 20}px` }"
            @click="navigate">
            {{ item.title }}
        </div>

        <!-- 渲染子级导航 -->
        <NavItem :activeSection="activeSection" v-if="item.children" v-for="child in item.children" :key="child.id" :item="child" :level="level + 1"
            @navigate="$emit('navigate', $event)" />
    </div>
</template>
  
<script>
import NavItem from './NavItem.vue'; // 导入递归组件
export default {
    name: 'NavItem',
    components: {
        NavItem
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            default: 0 // 当前层级，默认是 0
        }, activeSection: {
            type: String,
            default: '0'
        },
    },
    computed: {
        isActive() {
            // 可根据逻辑判断是否高亮当前导航项
            // 比如可以通过路由或其他状态判断
            return false;
        }
    },
    methods: {
        navigate() {
            // 触发导航事件
            this.$emit('navigate', this.item.id);
        }
    }
};
</script>
  
<style>
.nav-item {
    cursor: pointer;
    padding: 5px 0;
    transition: background-color 0.2s;
}

.nav-item:hover {
    background-color: #f5f5f5;
}

.nav-item.active {
    font-weight: bold;
    color: #007bff;
}
</style>
  